import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _ExternalFactory } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../editor/AccountEditor";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";



export const ExternalFactory = () => {

    const externalfactory = useDataBean(_ExternalFactory);
    const single = Singleton.getInstance();
    const [regexStr, setregexStr] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        externalfactory.instance.getExternalFactoryCatalog(null, null, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        externalfactory.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        externalfactory.instance.deleteExternalFactory(externalfactory.bean.IDExternalFactory).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        externalfactory.instance.updateExternalFactory(externalfactory.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDExternalFactory', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${externalfactory.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Maquilas - Centros de Fabricación Externos">
            <div className="row">
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={externalfactory.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Tipo</label>
                                <input type="text" name="Type" className="form-control" value={externalfactory.bean.Type} onChange={(e) => { externalfactory.setBean({ ...externalfactory.bean, 'Type': parseInt(e.target.value) }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={externalfactory.bean.Name} onChange={externalfactory.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-12">
                                <AccountEditor label="Tercero" idAccount={externalfactory.bean.IDAccount} onChange={(e) => { externalfactory.setBean({ ...externalfactory.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={externalfactory.bean.Description} onChange={externalfactory.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {externalfactory.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}